import { _ } from "i18n";

interface DiscoverGamesBulkUpdateButtonProps {
	/** Selection-based disable (no rows selected). */
	disabled: boolean;
	/** Whether the user is permitted to perform bulk updates at all. */
	canBulkUpdate: boolean;
	tooltip: string;
	onClick: () => void;
}

export function DiscoverGamesBulkUpdateButton({
	disabled,
	canBulkUpdate,
	tooltip,
	onClick,
}: DiscoverGamesBulkUpdateButtonProps) {
	// Reuse the shared, already-registered "No permissions" string (translation keys live in a
	// remote store; this avoids shipping an unregistered key that would render as raw text).
	const effectiveTooltip = canBulkUpdate
		? tooltip
		: _("discover.gamesTable.programGame.noPermissionHint");

	return (
		<span className="discoverGamesTableV3-bulkUpdateWrap" title={effectiveTooltip}>
			<button
				type="button"
				className="discoverGamesTableV3-columnBtn"
				disabled={disabled || !canBulkUpdate}
				onClick={onClick}
			>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
					<path
						d="M2.5 4h11M2.5 8h11M2.5 12h7"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
					/>
					<path
						d="M12.5 10.5l2 2-2 2"
						stroke="currentColor"
						strokeWidth="1.3"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
				{_("discover.gamesTable.bulkUpdate.button")}
			</button>
		</span>
	);
}
